module.exports = require('./helpers/bundle-url').getBundleURL('jJw6J') + "logo-dark.eefe0b7f.svg";